export const CATALOG_CONSTANTS = {
  BULK_UPLOAD: {
    LABEL: 'Upload item data',
    MESSAGE_LOADING_UPLOAD_MFE: 'Upload control is loading, please wait...',
    MESSAGE_UPLOAD_ACTION_PROGRESS: 'File upload in progress, please wait...',
  },
  DOWNLOAD_ITEM_DATA: {
    MESSAGE_LOADING_DOWNLOAD_MFE: 'Loading download item data',
  },
}
